import * as CONSTANTS from '../../constants';

/**
 * Toggle the info widget.
 *
 * @param commit
 */
export const toggleInfoWidget = ({ commit }) => {
    commit(CONSTANTS.INFO_WIDGET_TOGGLE)
};

/**
 * Select a specific page.
 *
 * @param commit
 * @param payload
 */
export const pageSelect = ({ commit }, payload) => {
    commit(CONSTANTS.INFO_WIDGET_PAGE_SELECT, payload);
};

/**
 * Increment the page.
 *
 * @param commit
 * @param payload
 */
export const pageIncrement = ({ commit }, payload) => {
    commit(CONSTANTS.INFO_WIDGET_PAGE_INCREMENT, payload);
};

/**
 * Reset the page for the widget.
 *
 * @param commit
 */
export const pageReset = ({ commit }) => {
    commit(CONSTANTS.INFO_WIDGET_PAGE_RESET);
};


// WEBPACK FOOTER //
// ./src/store/modules/info/actions.js